import {
  Menu,
} from '@/internal';
import {
  openGeneralFeedbackPrompt,
} from '@/utils/feedback.js';

export default (payload = {}) => {
  return new Menu({
    title: 'Community',
    open: true,
    menuItems: [
      {
        href: 'https://www.facebook.com/groups/444623373019965',
        icon: 'facebook',
        iconPack: 'fa-brands',
        target: '_blank',
        title: 'FB Group',
      },
      {
        title: 'Share Idea',
        icon: 'lightbulb-exclamation-on',
        onClick: async () => {
          window.dispatchEvent(new CustomEvent('v3me:feature-idea-prompt'));
        }
      },
      {
        title: 'Send Feedback',
        icon: 'message-lines',
        onClick: () => {
          openGeneralFeedbackPrompt({
            promptLocation: 'account_menu',
          });
        },
      },
      {
        title: "What's New",
        count: payload.changelogUnread,
        icon: 'bullhorn',
        onClick: () => {
          window.dispatchEvent(new CustomEvent('v3me:changelog'));
        },
      },
      // {
      //   route: window.app.findRouteByName('marketplace/index'),
      // },
    ],
  });
};
